<script setup>
import TheCalendar from "@/components/Admin/TheCalendar";
import {useStore} from "vuex";
import {useRoute} from "vue-router"
import {useRouter} from "vue-router"
import {useScrollBottom} from "@/use/scroll-bottom";
import {ref, computed, onMounted} from "vue";
import axios from "axios";
//----------------------------------------------------------------------
const store = useStore()
const route = useRoute()
const router = useRouter()
// const router = useRouter()
// вариант получения:  Лично в офисе(1)/В личном кабинете(2)/Почтой РФ(3)
const actionType = ref(0)
const isLoading = ref(false)
const isSubmitting = ref(false)
const isSubmitComplete = ref(false)
const address = ref('')
const isAddressEmpty = ref(false)

// тип справки
const docType = ref({})
const years = ref([])
//Для основного заемщика
const isMain = ref(false)
// Для всех созаемщиков
const isAll = ref(false)
// список лет для справки в налоговую
const applYears = ref([])

//----------------------------------------------------------------------

onMounted( ()=>{
  store.commit('menuModule/initMenu')
  store.commit('dateModule/initDateAction')
  isLoading.value = true

  if (route.path === '/application/fns' && +user.value['type'] === 1){
    init()
    docType.value = {
      id: 2,
      title: 'Заказать справку в Федеральную налоговую службу (ФНС России)'
    }
  } else if (route.path === '/application/fns' && +user.value['type'] === 2){

    // в рассрочке нет такой справки
    router.push('/applications')

  } else if (route.path === '/application/pfr'){
    docType.value = {
      id: 3,
      title: 'Заказать справку в Пенсионный Фонд России'
    }
  } else if (route.path === '/application/balance'){
    docType.value = {
      id: 4,
      title: 'Заказать справку об остатке ссудной задолженности'
    }
  } else if (route.path === '/application/credit'){
    docType.value = {
      id: 5,
      title: 'Заказать справку о кредитной истории/акт сверки'
    }
  }

})

const init = async () => {
  const url = process.env.VUE_APP_API + "appl-years.php"
  await axios
      .get(url)
      .then(response => (applYears.value = response.data))
      .catch(error => alert(error));
}

//----------------------------------------------------------------------

const getActionType = (t) => {
  return actionType.value === t
}

const setActionType = (t) => {
  //if (t === 3) setTimeout(() => useScrollBottom(), 300);
  actionType.value = t;
  setTimeout(() => useScrollBottom(), 300);
}
const setMain = () => isMain.value = !isMain.value
const setAll = () => isAll.value = !isAll.value
const setYear = (year) => {
  // если год есть, то удалить, если нет - добавить
  let index = years.value.indexOf(year)
  if (index === -1){
    years.value.push(year);
  } else {
    years.value.splice(index, 1)
  }
  // сортировка по году
  years.value.sort((a, b) => a - b)
  //years.value.sort()
  //console.log(years.value)
}
//----------------------------------------------------------------------

// отправка заявления
const onSubmit = async () => {

  try {
    // если почта РФ, то валидация адреса
    if (actionType.value === 3 && address.value.trim() === '') {
      isAddressEmpty.value = true
    } else {

      // отправка данных
      isSubmitting.value = true

      const headers = {
        'Authorization': 'Bearer ' + token.value
      }

      /*
      docType:
      case 1: $Act = "Досрочное погашение";
      case 2: $Act = "Справка в Инспекцию ФНC";
      case 3: $Act = "Справка в Пенсионный Фонд";
      case 4: $Act = "Справка об остатке ссудной задолженности";
      case 5: $Act = "Справка о кредитной истории";
      case 20: $Act = "Кредитные каникулы";
      */

      const values = {
        'docType': docType.value['id'],
        'actionType': actionType.value,
        'dateReceiving': dateAction.value,
        'address': address.value,
        'main': isMain.value,
        'all': isAll.value,
        'years': years.value
      }

      const payload = {values, ...{'section': user.value.type}, ...{'userId': user.value.id}}

      //console.log(headers)
      //console.log(payload)
      const url = process.env.VUE_APP_API + "create-document.php"

      const {data} = await axios.post(url, payload, {
        headers: headers
      })

      //console.log(data)

      if (data['status'] === 'SUCCESS'){
        isSubmitComplete.value = true
      }

    }

  } catch (e) {
    alert ('INTERNAL_SERVER_ERROR')
  }

}

// доступ к разделу выбор типа доставки
const isActionTypesAvailable = () => {
  return (docType.value['id'] === 2 && (isMain.value || isAll.value) && years.value.length > 0) || (docType.value['id'] !== 2 && dateAction.value)
}

// доступ к кнопке ОТПРАВТЬ
const isSubmitAvailable = () => {
  return isActionTypesAvailable && actionType.value > 0
}

//----------------------------------------------------------------------
const dateAction = computed( () => {return store.getters['dateModule/dateAction']})
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})

</script>

<template>
  <main class="content-wrapper">

    <section class="content-header">
      <div class="container-fluid application-content">
        <div class="row">
          <div class="col">
            <h3>{{ docType['title'] }}</h3>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div v-if="isLoading" class="container-fluid application-content">

        <!-- если isSubmitComplete=true показываем сообщение что заявление отправлено -->
        <div v-if="!isSubmitComplete">

          <div class="number">1</div>
          <div class="v-line"></div>
          <div class="info text-center">
            <h4 class="text-center">Выберите дату получение справки</h4>
            Справку можно получить не ранее, чем через пять дней после подачи заявки.
          </div>

          <div class="v-line"></div>
          <TheCalendar minDelay="5"></TheCalendar>

          <div class="row" v-if="dateAction">
            <div class="v-line"></div>
            <div class="col-12">
              <div class="card card-outline card-info m-0">
                <div class="card-body">
                  <table
                      class="table"
                  >
                    <tbody>
                    <tr>
                      <td class="border-0 t-col-1">Дата получения справки</td>
                      <td class="border-0 t-col-2">{{ dateAction }}</td>
                    </tr>
                    </tbody>
                  </table>

                  <!-- Только для справок в налоговую -->

                  <div v-if="docType['id'] === 2">

                    <hr>

                    <div class="custom-control custom-checkbox mt-3 ml-2">
                      <input
                          @click="setMain()"
                          class="custom-control-input custom-control-input-info" type="checkbox" id="nalog-main" name="nalog-main"
                      >
                      <label for="nalog-main" class="custom-control-label">Для основного заемщика</label>
                    </div>

                    <div class="custom-control custom-checkbox mt-3 ml-2">
                      <input
                          @click="setAll()"
                          class="custom-control-input custom-control-input-info" type="checkbox" id="nalog-all" name="nalog-all"
                      >
                      <label for="nalog-all" class="custom-control-label">Для всех созаемщиков</label>
                    </div>

                    <hr>

                    <div
                        v-for="year in applYears" :key="year"
                        class="custom-control custom-checkbox mt-3 ml-2"
                    >
                      <input
                          @click="setYear(year)"
                          class="custom-control-input custom-control-input-info" type="checkbox" :id='"nalog-" + year' :name='"nalog-" + year'
                      >
                      <label :for='"nalog-" + year' class="custom-control-label">За {{ year }} год</label>
                    </div>

                  </div>

                  <!-- --------------------------------------------------- -->

                </div>
              </div>
            </div>
          </div>

          <!-- шаг 2 выбор типа отправки справки -->
          <!-- если в ФНС и выбраны все условия, если не ФНС, то выбрана дата -->
          <div class="row" v-if="isActionTypesAvailable()">

            <div class="col-12 m-0">
              <div class="v-line"></div>
              <div class="number">2</div>
              <div class="v-line"></div>
              <div class="info text-center">
                <h4>Выберите вариант получения справки</h4>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 mt-4">
              <div
                  :class="['card card-outline card-info card-link', getActionType(1) ? 'selected-action' : '']"
                  @click="setActionType(1)"
              >
                <div class="card-body text-center">
                  <v-icon
                      v-if="actionType === 0 || actionType === 2 || actionType === 3"
                      class="service-icon mb-3"
                      icon="mdi:office-building-marker-outline"
                  ></v-icon>
                  <v-icon
                      v-else
                      class="service-icon--light mb-3"
                      icon="mdi:office-building-marker-outline"
                  ></v-icon>
                  <h5>Лично в офисе</h5>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 mt-4">
              <div
                  :class="['card card-outline card-info card-link', getActionType(2) ? 'selected-action' : '']"
                  @click="setActionType(2)"
              >
                <div class="card-body text-center">
                  <v-icon
                      v-if="actionType === 0 || actionType === 1 || actionType === 3"
                      class="service-icon mb-3"
                      icon="mdi:account-circle-outline"
                  ></v-icon>
                  <v-icon
                      v-else
                      class="service-icon--light mb-3"
                      icon="mdi:account-circle-outline"
                  ></v-icon>
                  <h5>В личном кабинете</h5>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 mt-4">
              <div
                  :class="['card card-outline card-info card-link', getActionType(3) ? 'selected-action' : '']"
                  @click="setActionType(3)"
              >
                <div class="card-body text-center">
                  <v-icon
                      v-if="actionType === 0 || actionType === 1 || actionType === 2"
                      class="service-icon mb-3"
                      icon="mdi:email"
                  ></v-icon>
                  <v-icon
                      v-else
                      class="service-icon--light mb-3"
                      icon="mdi:email"
                  ></v-icon>
                  <h5>Почтой РФ</h5>
                </div>
              </div>
              <div v-if="actionType == 3">
                <div class="v-line--mt"></div>
                <div class="number">3</div>
                <div class="v-line"></div>
              </div>
            </div>

            <div v-if="actionType == 3" class="col-12 m-0">
              <div class="info text-center">
                <h4>Укажите полный адрес доставки с почтовым индексом</h4>
              </div>
            </div>

            <div v-if="actionType == 3" class="col-12 mt-2">
              <div class="form-group">
                <textarea
                    :class="['form-control', isAddressEmpty ? 'is-invalid' : '']"
                    rows="3" placeholder="Адрес доставки"
                    v-model="address"
                    @keyup="isAddressEmpty = false"
                ></textarea>
              </div>
            </div>

            <div v-if="actionType == 2" class="col-12 text-center">Справка будет доступна для скачивания в разделе «Мои сообщения»</div>
          </div>

          <div class="row" v-if="isSubmitAvailable()">

            <div class="col-12">

              <div class="number mt-4">4</div>
              <div class="v-line"></div>

              <button
                  class="btn btn-send btn-block fs-15"
                  @click="onSubmit()"
              >
                <svg v-if="isSubmitting"
                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g>
                  <circle cx="3" cy="12" r="2" fill="#80b5d3"/>
                  <circle cx="21" cy="12" r="2" fill="#80b5d3"/>
                  <circle cx="12" cy="21" r="2" fill="#80b5d3"/>
                  <circle cx="12" cy="3" r="2" fill="#80b5d3"/>
                  <circle cx="5.64" cy="5.64" r="2" fill="#80b5d3"/>
                  <circle cx="18.36" cy="18.36" r="2" fill="#80b5d3"/>
                  <circle cx="5.64" cy="18.36" r="2" fill="#80b5d3"/>
                  <circle cx="18.36" cy="5.64" r="2" fill="#80b5d3"/>
                  <animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></g>
                </svg>
                <span v-else>Отправить заявление</span>
              </button>
            </div>
          </div>
        </div>

        <div v-else class="card card-outline card-success">
          <div class="card-body text-center">
            <v-icon
                class="success-icon--green mb-3"
                icon="mdi:check-circle-outline"
            ></v-icon>
            <h4 class="pt-2">Заявление успешно отправлено</h4>
          </div>
        </div>

      </div>
      <div v-else class="d-flex justify-content-center application-content">
        <div class="spinner-border text-primary m-4" role="status"></div>
      </div>
    </section>
    <br><br><br>
  </main>
</template>
<style scoped>
.application-content{
  width:800px;
  margin: 0 !important;
}

.fs-15{
  font-size: 1.5rem;
}
.selected-action{
  background-color: #80b5d3;
  color:#fff;
}
.card-link{
  cursor: pointer;
  transition: 0.3s;
}
.card-link:hover{
  -webkit-box-shadow: 0 0 15px 4px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 0 0 15px 4px rgba(34, 60, 80, 0.2);
  box-shadow: 0 0 15px 4px rgba(34, 60, 80, 0.2);
}
.number{
  display: flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  width:50px;
  height:50px;
  border:3px solid #80b5d3;
  border-radius:50%;
  font-size:1.2rem;
  margin: 0 auto;
}
.v-line{
  width:3px;
  height:40px;
  background-color: #80b5d3;
  margin: 0 auto;
}
.v-line--mt{
  width:3px;
  height:40px;
  background-color: #80b5d3;
  margin: -15px auto 0 auto;
}
.service-icon{
  width:50px;
  height:50px;
  color: #80b5d3;
}
.service-icon--light{
  width:50px;
  height:50px;
  color: #fff;
}
.t-col-1{
  width:65%;
}
.t-col-2{
  width:35%;
  font-size: 1.4rem;
  text-align: right;
}
.fs-15{
  font-size: 1.5rem;
}
.info{
  background-color: #80b5d3;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
}
.card-info.card-outline{
  border-top:3px solid #80b5d3;
}

.input-error{color:#dc3545;margin: 5px}

@media only screen and (max-width : 800px) {
  .t-col-1{
    width:65%;
  }
  .t-col-2{
    width:35%;
    font-size: 0.9rem;
    text-align: right;
  }
  .application-content{
    width:100%;
  }
}

@media only screen and (max-width : 460px) {
  .input-control{
    width:100%
  }
}
</style>